module.exports = __webpack_public_path__ + "img/pharm_partner_welcome_logo_white.c3c1d1bc.png";